<template>
    <div class="base-range-counter">
        <button
            class="base-range-counter__operation"
            :class="{ '-disabled': minimumReached }"
            @click="decrease"
        >
            <span class="base-range-counter__operation--decrease"></span>
        </button>
        <div class="base-range-counter__counter-value">
            {{ counterValue }}
            <slot name="counterMeasure"></slot>
        </div>
        <button
            class="base-range-counter__operation"
            :class="{ '-disabled': maximumReached }"
            @click="increase"
        >
            <base-icon
                name="add"
                size="xlarge"
            ></base-icon>
        </button>
    </div>
</template>

<script>
import BaseIcon from '@RepoComponent/BaseIcon/BaseIcon';

export default {
    name: 'BaseRangeCounter',

    components: {
        BaseIcon,
    },

    props: {
        counterValue: {
            type: Number,
            require: true,
        },
        minimumReached: {
            type: Boolean,
            default: false,
        },
        maximumReached: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        increase() {
            if (this.maximumReached) return;

            this.$emit('increase');
        },

        decrease() {
            if (this.minimumReached) return;

            this.$emit('decrease');
        },
    },
};
</script>

<style src="./BaseRangeCounter.scss" lang="scss" scoped></style>
